/**
 * Local/dev-only auth bypass for viewing /u/dashboard without Keycloak.
 * Hard-gated to NODE_ENV === 'development' so production builds never bypass.
 */
export const isDevAuthBypass =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_SKIP_AUTH === 'true';
